import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { PageComponent } from './page.component';
import { TranslateModule } from '@ngx-translate/core';
import { ProjectionModule } from '../../container-components/projection/projection.module';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { DeviationTypeModule } from '../deviation-type';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [PageComponent],
  imports: [
    IntrackFeatureModule,
    RouterModule,
    MatTabsModule,
    MatButtonModule,
    MatProgressBarModule,
    ProjectionModule,
    TranslateModule.forChild({}),
    DeviationTypeModule,
    SvgIconModule,
  ],
  exports: [PageComponent],
})
export class PageModule {}
